module.exports = __webpack_public_path__ + "img/bg-3.f3f3f792.jpg";